import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sitekey: String,
    callback: String,
  }

  connect() {
    if (!window.grecaptcha) {
      this.loadRecaptchaScript()
    } else {
      this.renderRecaptcha()
    }
  }

  loadRecaptchaScript() {
    const script = document.createElement("script")
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoad"
    script.async = true
    script.defer = true
    document.head.appendChild(script)

    window.onRecaptchaLoad = () => {
      this.renderRecaptcha()
    }
  }

  renderRecaptcha() {
    if (window.grecaptcha && !this.element.querySelector(".g-recaptcha-bubble")) {
      window.grecaptcha.render(this.element, {
        sitekey: this.sitekeyValue,
        callback: window[this.callbackValue] || this.callbackValue,
        size: "invisible",
      })
    }
  }

  disconnect() {
    this.element.innerHTML = ""
  }
}
